import { render, staticRenderFns } from "./UpdatePlatformSchedulingModal.vue?vue&type=template&id=13620bbe&scoped=true&"
import script from "./UpdatePlatformSchedulingModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePlatformSchedulingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13620bbe",
  null
  
)

export default component.exports